import { apiGet, apiPost, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

//GET APIS
export const getCompanyAPI = () => {
  return apiGet('mgmt/company')
}

export const getCompaniesAPI = () => {
  return apiGet('mgmt/company/list')
}

export const getCompanyFeaturesAPI = () => {
  return apiGet('mgmt/company/features')
}

export const getCommittedConfigAPI = () => {
  return apiGet('mgmt/settings/committed-config')
}

export const getDeveloperKeysAPI = () => {
  return apiGet('mgmt/devkeys/ListDeveloperKeys')
}

export const getMemberGroupsAPI = () => {
  return apiGet('mgmt/settings/memberGroups')
}

export const getTerminalsAPI = () => {
  return apiGet('mgmt/terminals')
}

export const getVehiclesAPI = () => {
  return apiGet('mgmt/vehicles')
}

export const fetchVehiclesWithTermAPI = (term) => {
  return apiGet(`mgmt/vehicles?term=${term}`)
}

export const getVehicleByIdAPI = (id) => {
  return apiGet(`mgmt/vehicles/${id}`)
}

export const getStripeCustomerAPI = (companyId) => {
  return apiGet(`mgmt/company/${companyId}/getCustomer`)
}

export const getStripeCustomerPaymentsAPI = (customerId) => {
  return apiGet(`mgmt/company/payments/${customerId}`)
}

export const getMemberAttributesAPI = () => {
  return apiGet(`mgmt/attributes/memberUniqueAttributes`)
}

// Update APIS

export const updateCompanyAPI = (company) => {
  Hotjar.event('update_company')
  return apiPost('mgmt/company', company)
}

export const deleteMembersAPI = (data) => {
  Hotjar.event('delete_members')
  return apiPost(`mgmt/reset/delete/members`, data)
}

export const saveNewVehicleAPI = (vehicle) => {
  Hotjar.event('save_new_vehicle')
  return apiPost('mgmt/vehicles', vehicle)
}

export const deleteVehicleAPI = (id) => {
  Hotjar.event('delete_vehicle')
  return apiDelete(`mgmt/vehicles/${id}`)
}

export const deleteVendorsAPI = (data) => {
  Hotjar.event('delete_vendors')
  return apiPost(`mgmt/reset/delete/vendors`, data)
}

export const deletePhysiciansAPI = (data) => {
  Hotjar.event('delete_physicians')
  return apiPost(`mgmt/reset/delete/physicians`, data)
}

export const updateMemberGroupAPI = (memberGroup) => {
  Hotjar.event('update_member_group')
  return apiPost(`mgmt/settings/memberGroups/${memberGroup.id}`, memberGroup)
}

export const updateVehicleAPI = (vehicle) => {
  Hotjar.event('update_vehicle')
  return apiPost(`mgmt/vehicles/${vehicle.id}`, vehicle)
}

export const updateTerminalAPI = (terminal) => {
  Hotjar.event('update_terminal')
  return apiPost(`mgmt/terminals/${terminal.id}`, terminal)
}

export const updateDeveloperKeysAPI = (developerKey) => {
  Hotjar.event('update_developer_keys')
  return apiPut(`mgmt/devkeys/${developerKey.id}`, developerKey)
}

export const updateStripeCustomerAddressAPI = (data) => {
  Hotjar.event('update_stripe_customer_address')
  return apiPost('mgmt/company/updateStripeCustomerAddress', data)
}

export const updateCompanyEmployeeSeatSubscriptionAPI = (data) => {
  Hotjar.event('update_company_employee_seat_subscription')
  return apiPost('mgmt/company/updateCompanyEmployeeSeatSubscription', data)
}

export const attachCustomerSourceAPI = (data) => {
  Hotjar.event('attach_customer_source')
  return apiPost('mgmt/company/attachCustomerSource', data)
}

export const setCustomerDefaultSourceAPI = (data) => {
  Hotjar.event('set_customer_default_source')
  return apiPost('mgmt/company/setCustomerDefaultSource', data)
}

export const removeCustomerSourceAPI = (data) => {
  Hotjar.event('remove_customer_source')
  return apiPost('mgmt/company/removeCustomerSource', data)
}

export const updateSubscriptionDefaultPaymentAPI = (data) => {
  Hotjar.event('update_subscription_default_payment')
  return apiPost('mgmt/company/updateSubscriptionDefaultPayment', data)
}

export const updateMemberAttributesAPI = (data) => {
  Hotjar.event('update_member_attributes')
  return apiPost('mgmt/attributes/memberAttributes', data)
}

// Add APIS
export const addMemberGroupAPI = (memberGroup) => {
  Hotjar.event('add_member_group')
  return apiPost(`mgmt/settings/memberGroups/`, memberGroup)
}

export const addTerminalAPI = (terminal) => {
  Hotjar.event('add_terminal')
  return apiPost(`mgmt/terminals`, terminal)
}

export const addDeveloperKeysAPI = (devKey) => {
  Hotjar.event('add_developer_keys')
  return apiPost(`mgmt/devkeys`, devKey)
}

//Delete APIS
export const deleteTerminalAPI = (terminalId) => {
  Hotjar.event('delete_terminal')
  return apiDelete(`mgmt/terminals/${terminalId}`)
}

export const deleteMemberGroupAPI = (memberGroupId) => {
  Hotjar.event('delte_member_group')
  return apiDelete(`mgmt/settings/memberGroups/${memberGroupId}`)
}

export const getAllPermissionsAPI = () => {
  return apiGet(`mgmt/roles/permissions`)
}

export const getPermissionsByCompanyAPI = () => {
  return apiGet(`mgmt/roles/permissionsByCompany`)
}

export const updateRoleAPI = (data) => {
  Hotjar.event('update_role')
  return apiPut(`mgmt/roles/${data.id}/updateRole`, data)
}

export const assignPermissionsAPI = (data) => {
  Hotjar.event('assing_permissions')
  return apiPost('mgmt/roles/assignPermission', data)
}

export const saveNewRoleAPI = (data) => {
  Hotjar.event('save_new_role')
  return apiPost('mgmt/roles', data)
}

export const deleteDeveloperKeysAPI = (devKey) => {
  Hotjar.event('delete_developer_keys')
  return apiDelete(`mgmt/devkeys/${devKey}`)
}

//Regions APIs

export const getRegionsAPI = () => {
  return apiGet(`mgmt/region`)
}

export const saveNewRegionAPI = (data) => {
  Hotjar.event('save_region')
  return apiPost('mgmt/region', data)
}

export const updateRegionAPI = (region) => {
  Hotjar.event('update_region')
  return apiPut(`mgmt/region/${region.id}`, region)
}

export const deleteRegionAPI = (regionId) => {
  Hotjar.event('delete_region')
  return apiDelete(`mgmt/region/${regionId}`)
}

export const regionByTerminalAPI = () => {
  return apiGet(`mgmt/region/getListRegionsStore`)
}

// Add RegionsByIdAPI
export const getRegionByIdAPI = (id) => {
  return apiGet(`mgmt/region/${id}`)
}

// Add kml by id
export const getKmlByIdAPI = (key) => {
  return apiGet(`mgmt/assets/${key}`)
}

//Add Taxe Rule by Company
export const getTaxRuleByCompanyAPI = () => {
  return apiGet(`mgmt/deliveryTaxRate/byCompany`)
}

export const saveCompanyAgreementAPI = (employeeId, clickwrapId) => {
  Hotjar.event('save_company_agreeement')
  return apiPost(`mgmt/docusign/${employeeId}/saveCompanyAgreement/${clickwrapId}`, {})
}

export const overlappingRegionAPI = (polygons) => {
  return apiPost('mgmt/region/overlapping', polygons)
}



// WEBPACK FOOTER //
// ./src/api/company.js